import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const CSDWorkshopBigDataAnalytics2026 = () => {
    const images = [
        "1.jpeg",
        "2.jpeg",
        "3.jpeg",
        "4.jpeg"
    ];

    const baseUrl = "https://admin.swec.ac.in/assetsswec/img/csd-big-data-workshop-2026/";

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">

                                <h2>
                                    CSD Workshop on Big Data Analytics (Jan 29–31, 2026)
                                </h2>

                                <div className='py-2'>
                                    <p>
                                        A workshop on <strong>Big Data Analytics</strong> was conducted for <strong>3rd year CSD students</strong> from <strong>29th January to 31st January 2026</strong>, focusing on fundamental concepts, tools, and real-world applications.
                                    </p>

                                    <p>
                                        The sessions were delivered by <strong>K. Venu</strong>, an industry expert in Big Data and cloud technologies, who provided both theoretical knowledge and hands-on training.
                                    </p>

                                    <p>
                                        The workshop successfully enhanced students’ practical skills and strengthened their understanding of modern data analytics techniques.
                                    </p>
                                </div>

                                <div className="spotlight-group">
                                    <div className="row">
                                        {images.map((img, index) => (
                                            <div key={index} className="col-md-6 mb-3">
                                                <a
                                                    className="spotlight"
                                                    href={`${baseUrl}${img}`}
                                                >
                                                    <img
                                                        src={`${baseUrl}${img}`}
                                                        alt={`Big Data Workshop Image ${index + 1}`}
                                                        className="img-responsive"
                                                    />
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default CSDWorkshopBigDataAnalytics2026;